// CapitalApiClient.js

import axios from "axios";

class CapitalApiClient {
  constructor() {
    this.apiKey = null;
    this.identifier = null;
    this.password = null;
    this.baseUrl = null;
    this.cst = null;
    this.securityToken = null;
    this.tokenExpiration = null;
  }

  init(apiKey, identifier, password, baseUrl) {
    this.apiKey = apiKey;
    this.identifier = identifier;
    this.password = password;
    this.baseUrl = baseUrl;
    console.log(`Initializing with base URL: ${baseUrl}`);
  }

  setBaseUrl(baseUrl) {
    if (this.baseUrl !== baseUrl) {
      this.baseUrl = baseUrl;
      // Reset auth tokens when switching environments
      this.cst = null;
      this.securityToken = null;
      this.tokenExpiration = null;
    }
  }

  async getAuthTokens() {
    if (this.isTokenValid()) {
      return { cst: this.cst, securityToken: this.securityToken };
    }

    try {
      console.log(`Authenticating with base URL: ${this.baseUrl}`);
      const response = await axios.post(
        `${this.baseUrl}/session`,
        { identifier: this.identifier, password: this.password },
        { headers: { "X-CAP-API-KEY": this.apiKey } }
      );

      this.cst = response.headers["cst"];
      this.securityToken = response.headers["x-security-token"];
      this.tokenExpiration = Date.now() + 3600000; // Set expiration to 1 hour from now

      return { cst: this.cst, securityToken: this.securityToken };
    } catch (error) {
      console.error("Authentication error:", error);
      throw error;
    }
  }

  isTokenValid() {
    return this.cst && this.securityToken && Date.now() < this.tokenExpiration;
  }

  async request(method, endpoint, data = null) {
    const { cst, securityToken } = await this.getAuthTokens();

    try {
      console.log(`${this.baseUrl}${endpoint}`);
      const response = await axios({
        method,
        url: `${this.baseUrl}${endpoint}`,
        headers: {
          "X-SECURITY-TOKEN": securityToken,
          CST: cst,
        },
        data,
      });

      return response.data;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }

  // Add this method to the CapitalApiClient class
  clearSession() {
    this.cst = null;
    this.securityToken = null;
    this.tokenExpiration = null;
    console.log("Session cleared, will create a new one on next request");
  }
}

export const capitalApiClient = new CapitalApiClient();
